import { CodementumUrl } from '@cm-frontend/shared/codementum-url';

export default function codementumUrlStoreModule() {
  return {
    namespaced: true,
    getters: {
      buildMode() {
        return CodementumUrl.buildMode;
      },
      buildLink() {
        return (url: string, path = '') => new URL(path, url).href;
      },
      storage() {
        return CodementumUrl.storage;
      },
      origin() {
        return CodementumUrl.baseUrl;
      },
      website() {
        return CodementumUrl.website();
      },
      panel() {
        return CodementumUrl.panel();
      },
      studio() {
        return CodementumUrl.studio();
      },
      studio2() {
        return CodementumUrl.studio2();
      },
      studioevent() {
        return CodementumUrl.studioevent();
      },
      studioevent2() {
        return CodementumUrl.studioevent2();
      },
      stemolympiad() {
        return CodementumUrl.studioevent().replace(
          'studioevent',
          'stemolympiad'
        );
      },
      stemolympiad2() {
        return CodementumUrl.studioevent2().replace(
          'studioevent2',
          'stemolympiad2'
        );
      },
      appmaker() {
        return CodementumUrl.appmaker();
      },
      gamemaker() {
        return CodementumUrl.gamemaker();
      },
      aiml() {
        return CodementumUrl.aiml();
      },
      api() {
        return CodementumUrl.api();
      },
      authApi() {
        return CodementumUrl.authApi();
      },
      panelApi() {
        return CodementumUrl.panelApi();
      },
      gamemakerApi() {
        return CodementumUrl.gamemakerApi();
      },
      appmakerApi() {
        return CodementumUrl.appmakerApi();
      },
      aimlApi() {
        return CodementumUrl.aimlApi();
      },
      studioApi() {
        return CodementumUrl.studioApi();
      },
      studio2Api() {
        return CodementumUrl.studio2Api();
      },
      studioXApi() {
        return CodementumUrl.studioXApi.bind(CodementumUrl);
      }
    }
  };
}
